var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoodGreatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#FDE68A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4651 17.4572C29.4651 14.5603 31.7854 12.2038 34.639 12.2038C37.4908 12.2038 39.8111 14.5597 39.8111 17.4572C39.8111 18.291 39.1458 18.9667 38.3248 18.9667C37.5038 18.9667 36.8386 18.291 36.8386 17.4572C36.8386 16.2249 35.8517 15.2227 34.639 15.2227C33.425 15.2227 32.4375 16.2249 32.4375 17.4572C32.4375 18.291 31.7723 18.9667 30.9513 18.9667C30.1303 18.9667 29.4651 18.2904 29.4651 17.4572Z",
    fill: "#4C555F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9839 17.4409C12.9839 14.5446 15.3048 12.1875 18.1578 12.1875C21.0096 12.1875 23.3305 14.544 23.3305 17.4409C23.3305 18.2747 22.6652 18.9504 21.8442 18.9504C21.0232 18.9504 20.358 18.2747 20.358 17.4409C20.358 16.2086 19.3711 15.2064 18.1578 15.2064C16.9438 15.2064 15.9563 16.2086 15.9563 17.4409C15.9563 18.2747 15.2911 18.9504 14.4701 18.9504C13.6491 18.9504 12.9839 18.2741 12.9839 17.4409Z",
    fill: "#4C555F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3246 30.9352C11.9465 30.0121 12.3775 28.9518 13.2876 28.5678C13.5112 28.4743 13.743 28.4296 13.9713 28.4296C14.6704 28.4296 15.3339 28.8492 15.6187 29.5466C17.2696 33.5834 21.3585 36.1905 26.036 36.1905C30.6077 36.1905 34.6729 33.5816 36.3921 29.5423C36.7833 28.624 37.8332 28.2008 38.7368 28.5986C39.6405 28.9965 40.0566 30.0622 39.6654 30.9799C37.3808 36.3456 32.0303 39.8125 26.0354 39.8125C19.9121 39.8125 14.5301 36.3287 12.3246 30.9352Z",
    fill: "#4C555F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodGreatIcon);
export default __webpack_public_path__ + "static/media/MoodGreatIcon.9ad0b5651cca8f6eb1a57ccf44a69c67.svg";
export { ForwardRef as ReactComponent };